module.exports = __webpack_public_path__ + "media/headerbg.0d4d3836.webm";